// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import PhotoRatio from "./config-form-subsections/PhotoRatio";
import GreenScreenSettings from "./config-form-subsections/GreenScreenSettings";
import MosaicSettings from "./config-form-subsections/MosaicSettings";

import * as Constants from "../../../constants/photoDimensions";
import ImageField from "../../components/ImageField";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class GifSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gifOverlayNumber: 0
    };

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    this.handleLocalChange = this.handleLocalChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleLocalChange(event) {
    this.setState({
      [event.target.name]: event.target.value
    });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;
    const { gifOverlayNumber } = this.state;

    const overlays = [];
    for (let i = 0; i < gifOverlayNumber; i++) {
      overlays.push(
        <FormGroup row>
          <ImageField
            id={"gifOverlay".concat(i + 1)}
            label={"Overlay ".concat(i + 1)}
            required={i + 1 < 5} // only the first four are required
            image={files["gifOverlay".concat(i + 1, "File")]}
            width={
              config.photoRatio == 1
                ? Constants.PictureWidth
                : Constants.PictureHeight
            }
            height={
              config.photoRatio == 1
                ? Constants.PictureHeight
                : Constants.PictureWidth
            }
            onDeleteChange={this.handleCheckboxChange}
            onFileChange={this.handleValidatedFileChange}
          />
        </FormGroup>
      );
    }

    return (
      <React.Fragment>
        <Section title="GIF settings" subsection>
          <FormGroup row>
            <ImageField
              id="stripBranding"
              label="Strip branding"
              required
              image={files.stripBrandingFile}
              width={
                config.photoRatio == 1
                  ? Constants.LandscapeStripWidth
                  : Constants.PictureHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.LandscapeStripHeight
                  : Constants.PictureWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>

          <FormGroup row className="ml-2">
            <Label for="sendGif">
              <Col>
                {config.sendGif ? (
                  <Input
                    checked
                    type="checkbox"
                    name="sendGif"
                    id="sendGif"
                    onChange={this.handleCheckboxChange}
                  />
                ) : (
                  <Input
                    type="checkbox"
                    name="sendGif"
                    id="sendGif"
                    onChange={this.handleCheckboxChange}
                  />
                )}
                Receive animated gif by email
              </Col>
            </Label>
          </FormGroup>

          <Section title="GIF overlays" closed subsection>
            <FormGroup row>
              <Label for="gifOverlayNumber" sm={2}>
                GIF overlays count
              </Label>
              <Col sm={10}>
                <Input
                  value={gifOverlayNumber}
                  type="select"
                  name="gifOverlayNumber"
                  id="gifOverlayNumber"
                  className="dropdown-black"
                  onChange={this.handleLocalChange}
                  required={config.setting == 2}
                >
                  <option value="" selected={!gifOverlayNumber} disabled>
                    -- Select gif overlays number --
                  </option>
                  <option value="0">0</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                </Input>
              </Col>
            </FormGroup>
            {overlays}
          </Section>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GifSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/GifSettings.jsx